export default "__VITE_ASSET__CPvc1ZZP__"